import styled from "styled-components";

const c = {
  ink: "rgba(0,0,0,0.85)",
  inkSoft: "rgba(0,0,0,0.55)",

  gold: "#c9a227",
  goldSoft: "rgba(201,162,39,0.25)",

  pink: "#fc9ac4",
  pinkStrong: "#ff77b4",
  pinkSoft: "rgba(252,154,196,0.18)",
};

export const InputWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input`
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.16);
  border-radius: 12px;

  padding: 12px 44px 12px 14px;
  outline: none;

  font-size: 15px;
  color: ${c.ink};
  background: rgba(255, 255, 255, 0.98);

  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;

  &:focus {
    border-color: rgba(201, 162, 39, 0.7);
    box-shadow:
      0 0 0 3px rgba(201, 162, 39, 0.18),
      0 0 0 6px rgba(252, 154, 196, 0.1);
  }

  &::placeholder {
    color: ${c.inkSoft};
  }
`;

export const EyeIcon = styled.button`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);

  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  color: ${c.pinkStrong};
  display: flex;
  align-items: center;
  justify-content: center;

  transition:
    transform 0.15s ease,
    color 0.15s ease;

  &:hover {
    transform: translateY(-50%) scale(1.08);
    color: ${c.pinkStrong};
  }

  &:focus {
    outline: none;
  }
`;
